/* Inquiry context stays in the page/form; no cookies, storage or analytics requests. */
(() => {
  const campaignKeys = ['utm_source', 'utm_medium', 'utm_campaign'];
  const sitePath = value => {
    if (typeof value !== 'string' || value.length > 240) return '';
    // Only public content paths; never carry account, checkout, query or fragment data.
    return /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?(?:(?:pages|products|collections|blogs)\/[a-z0-9-]+(?:\/[a-z0-9-]+)?\/?|)$/.test(value) ? value : '';
  };
  const campaignValue = value => /^[\p{L}\p{N} ._-]{1,100}$/u.test(value || '') ? value.trim() : '';
  const buildContext = (locationHref, referrer = '') => {
    const url = new URL(locationHref);
    let previous;
    try { previous = new URL(referrer); } catch { /* No referrer is normal. */ }
    const context = {
      inquiry_page: sitePath(url.pathname),
      source_page: sitePath(url.searchParams.get('source_page')) || (previous?.origin === url.origin ? sitePath(previous.pathname) : ''),
      referrer_domain: previous && ['https:', 'http:'].includes(previous.protocol) ? previous.hostname.slice(0, 253) : ''
    };
    for (const key of campaignKeys) context[key] = campaignValue(url.searchParams.get(key));
    return context;
  };
  const quoteDestination = (href, locationHref) => {
    const current = new URL(locationHref);
    const link = new URL(href, current);
    if (link.origin !== current.origin || !/\/pages\/request-quote\/?$/.test(link.pathname)) return null;
    const source = sitePath(current.pathname);
    if (source && !/\/pages\/request-quote\/?$/.test(source)) link.searchParams.set('source_page', source);
    for (const key of campaignKeys) {
      const value = campaignValue(current.searchParams.get(key));
      if (value) link.searchParams.set(key, value);
    }
    return link.pathname + link.search + link.hash;
  };
  const fillForms = scope => {
    const context = buildContext(window.location.href, document.referrer);
    scope.querySelectorAll('[data-inquiry-context]').forEach(input => {
      input.value = context[input.dataset.inquiryContext] || '';
    });
  };
  // Capture at activation so generated worksheet/model query strings remain intact.
  const prepareLink = event => {
    const anchor = event.target.closest?.('a[href]');
    if (!anchor) return;
    const destination = quoteDestination(anchor.href, window.location.href);
    if (destination) anchor.href = destination;
  };
  window.TaillaiInquiryContext = { buildContext, quoteDestination };
  fillForms(document);
  document.addEventListener('click', prepareLink, true);
  document.addEventListener('auxclick', prepareLink, true);
  document.addEventListener('shopify:section:load', event => fillForms(event.target));
})();
